import { useTranslation } from "@coworker/locales";
import ImagePreviewAddOn from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/ListItem/ImagePreviewAddOn/ImagePreviewAddOn";
import ListItem from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/ListItem/ListItem";
import ImageIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ImageIconPath";
import {
  NewOrExistingFile,
  useNewOrExistingFileUrls,
} from "@coworker/apprestructured/src/shared/types/newOrExistingFile";

interface ListViewProps {
  images: NewOrExistingFile[];
  onClick: () => void;
  disabled: boolean;
}

export default function ImagesListViewItem({
  images,
  onClick,
  disabled,
}: ListViewProps) {
  const { t } = useTranslation();

  const srcs = useNewOrExistingFileUrls(images);

  return (
    <ListItem
      title={images.length > 0 ? t("imagesString") : t("addImagesString")}
      onClick={onClick}
      description={
        images.length > 0
          ? images.length === 1
            ? `1 ${t("imageLowerCaseString")}`
            : `${images.length} ${t("imagesLowerCaseString")}`
          : ""
      }
      addOn={images.length > 0 ? <ImagePreviewAddOn srcs={srcs} /> : null}
      icon={ImageIconPath}
      disabled={disabled}
      emphasised={images.length > 0}
    />
  );
}
